import { doc, setDoc } from "firebase/firestore";
import { db } from "utilities/Firebase/firebase-redux";

export async function updateParkDataOnFirestore(data: any, uid: string) {
	const myDoc = doc(db, `Parks/${uid}`);
	return await setDoc(myDoc, data, { merge: true });
}
